import { render, staticRenderFns } from "./wxalink.vue?vue&type=template&id=d7710ff4&scoped=true&"
import script from "./wxalink.vue?vue&type=script&lang=js&"
export * from "./wxalink.vue?vue&type=script&lang=js&"
import style0 from "./wxalink.vue?vue&type=style&index=0&id=d7710ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7710ff4",
  null
  
)

export default component.exports